import MyDataHelps from "@careevolution/mydatahelps-js";

export default function getOuraProviderID() {
    var ouraProviderID = 45417;
    if (!MyDataHelps.baseUrl || MyDataHelps.baseUrl.startsWith("https://mdhorg.ce.dev")) {
        ouraProviderID = 10414;
    }
    return ouraProviderID;
}
